import { watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import localCache from '@/utils/cache'
import { useStore } from '@/store'
import { activeTab, markTabListInitialized, resetTabList, tabList, tabListInitialized } from '@/hooks/tab-list-state'

export { resetTabList }

let routeBound = false

function initTabList() {
  if (tabListInitialized) return
  const store = useStore()
  const firstMenu = store.getters['firstMenu']
  tabList.value = [
    {
      title: firstMenu?.menuName || '',
      path: firstMenu?.path || ''
    }
  ]
  const tabs = localCache.getCache('tabList')
  if (tabs) {
    tabList.value = tabs
  }
  markTabListInitialized()
}

function addTab(tab: any) {
  const isTabNotExisted = tabList.value.findIndex((item) => item.path === tab.path) === -1
  if (isTabNotExisted) {
    tabList.value.push(tab)
  }
  localCache.setCache('tabList', tabList.value)
}

function findPreviousTab(path: string) {
  const index = tabList.value.findIndex((tab) => tab.path === path)
  if (index === -1) return undefined
  return tabList.value[index - 1] || tabList.value[index + 1]
}

export function useTabList() {
  const route = useRoute()
  const router = useRouter()
  initTabList()

  if (!routeBound) {
    routeBound = true
    watch(
      () => route.fullPath,
      (fullPath) => {
        const tabPath = fullPath || route.path
        activeTab.value = tabPath
        addTab({
          title: (route.meta?.title as string) || String(route.name || ''),
          path: tabPath
        })
      },
      { immediate: true }
    )
  }

  const tabChange = (path: string) => {
    activeTab.value = path
    router.push(path)
  }

  const removeTab = (path: string, fallbackPath?: string) => {
    const previousTab = findPreviousTab(path)
    tabList.value = tabList.value.filter((tab) => tab.path !== path)
    localCache.setCache('tabList', tabList.value)

    if (activeTab.value === path || route.fullPath === path || route.path === path) {
      const targetPath = previousTab?.path || fallbackPath || '/admin/web'
      activeTab.value = targetPath
      router.push(targetPath)
    }
  }

  const handleCloseTab = (command: string) => {
    const indexPath = '/admin/web'
    if (command === 'closeOthers') {
      tabList.value = tabList.value.filter((tab) => tab.path === indexPath || tab.path === activeTab.value)
    } else if (command === 'closeAll') {
      activeTab.value = indexPath
      tabList.value = tabList.value.filter((tab) => tab.path === indexPath)
      router.push(indexPath)
    }
    localCache.setCache('tabList', tabList.value)
  }

  return {
    activeTab,
    tabList,
    tabChange,
    removeTab,
    handleCloseTab
  }
}
